
/**
 * Setup a player object.
 *
 * This is generally a user controlled Skier.
 * A player extends the Skiers properties and methods.
 *
 * @param  {Object} game  The Phaser Game object.
 * @param  {Number} x     The player x position.
 * @param  {Number} y     The player y position.
 * @param  {Object} group The player display group.
 */
Game.Prefabs.Player = function( game, x, y, group ) {

	// Call parent class.
	Game.Prefabs.Man.call( this, game, x, y, group );

	this.pname = 'player';

};


Game.Prefabs.Player.prototype = Object.create( Game.Prefabs.Man.prototype );


Game.Prefabs.Player.constructor = Game.Prefabs.Player;


/**
 * Move player.
 *
 * This method uses the player controls, and overrides the skier method which
 * will (eventually) do something similar in a multiplayer situation.
 */
Game.Prefabs.Player.prototype.controller = function() {

	// Store the previous controls.
	this.controls.prevUp = this.controls.up;
	this.controls.prevDown = this.controls.down;
	this.controls.prevLeft = this.controls.left;
	this.controls.prevRight = this.controls.right;
	this.controls.prevAction = this.controls.action;

	// Controls.
	this.controls.up = Game.Utils.Controls.cursor.up.isDown;
	this.controls.down = Game.Utils.Controls.cursor.down.isDown;
	this.controls.left = Game.Utils.Controls.cursor.left.isDown;
	this.controls.right = Game.Utils.Controls.cursor.right.isDown;
	this.controls.action = Game.Utils.Controls.action.isDown;

};


/**
 * Run arcade physics on the player.
 */
Game.Prefabs.Player.prototype.physics = function() {

	if ( this.follow || !this.alive ) {
		return;
	}

	// console.log( Game.Utils.Map.layer_collision );

	// game.physics.arcade.collide( this, Game.Utils.Map.layer_collision );

	// World collision
	game.physics.arcade.collide( this, Game.Utils.Map.layer_collision, Game.Utils.Map.player_collision_callback );

	// Platform collision
	game.physics.arcade.collide( this, Game.Utils.ManagePlatforms.platforms, Game.Utils.ManagePlatforms.collision_callback );

	// Stop crazy floating point maths where the number never actually zeroes because of friction.
	if ( Math.abs( this.body.velocity.x ) < 0.01 ) {
		this.body.velocity.x = 0;
	}

	// switch( this.state ) {

	// 	// If walking.
	// 	case Game.Prefabs.Man.states.WALK:

	// 		game.physics.arcade.collide( this, Game.Utils.Map.layer_collision );

	// 		break;

	// 	// Everything else.
	// 	// Skiing, jumping, etc.
	// 	default:

	// 		game.physics.arcade.collide( this, Game.Utils.Map.layer_collision, Game.Utils.Map.player_collision_callback, Game.Utils.Map.player_collision_check, this );

	// 		break;

	// }

};
